import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { Button } from '@design-system/components/button/button';
import { SetDoseCard } from '@client/new/components/SetDoseCard/SetDoseCard';
import { SwapProposal, SwapSet, rangeBoundError } from '../model/swaps.domain';
import { useDraftSets } from '../model/useDraftSets';
import { SwapThumb } from './SwapThumb';
import * as styles from './CreatorApprovedSwaps.css';

export const ExerciseSettingsModal = ({
  proposal,
  onSave,
  onClose,
}: {
  proposal: SwapProposal;
  onSave: (sets: SwapSet[]) => void;
  onClose: () => void;
}) => {
  const draft = useDraftSets(proposal.sets);

  return (
    <Modal
      isOpen
      onClose={onClose}
      title="Exercise settings"
      largeTitle
      primaryCta={{
        caption: 'Save',
        onClick: () => onSave(draft.toSwapSets()),
        state: draft.valid ? undefined : 'disabled',
      }}
      secondaryCta={{ caption: 'Cancel', onClick: onClose }}
      testId="exercise-settings-modal"
    >
      <div className={styles.modalExerciseRow}>
        <SwapThumb media={proposal.media} />
        <Typography>{proposal.name}</Typography>
      </div>
      <div className={styles.modalSets}>
        {draft.sets.map((set, i) => {
          const repsMaxError = rangeBoundError(set);
          return (
            <SetDoseCard
              key={set.key}
              label={`Set ${i + 1}`}
              set={set}
              onChange={(next) => draft.updateSet(set.key, next)}
              onUnitChange={draft.setUnit}
              onRemove={i !== 0 ? () => draft.removeSet(set.key) : undefined}
              errors={
                repsMaxError
                  ? { repsMax: { message: repsMaxError } }
                  : undefined
              }
            />
          );
        })}
        <Button
          color="primaryTonal"
          leftIcon={faPlus}
          className={styles.modalAddSetButton}
          onClick={draft.addSet}
        >
          Set
        </Button>
      </div>
    </Modal>
  );
};
